import React from 'react'
import { Link } from 'react-router-dom'
import { styled } from '@mui/material/styles'
import { Box, Typography, Stack, IconButton } from '@mui/material'
import PropTypes from 'prop-types'
import Iconify from '../../components/Iconify'

export default function About({ isMobile }) {

  const SummaryBox = styled(Box)(({ theme }) => ({
    marginTop: '30px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  }))

  const SummaryContent1 = styled(Typography)(() => ({
    fontSize: '1rem',
  }))

  const SocialIcons = () => (
    <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
      {socialLinks.map((link, index) => (
        <IconButton key={index} onClick={() => window.open(link.url, '_blank')} sx={{ color: 'text.primary', backgroundColor: '#b9d2fc', width: '35px', height: '35px' }}>
          <Iconify icon={link.icon} sx={{
      fontSize: link.icon === 'fa6-brands:x-twitter' ? 18 : 24,
    }}/>
        </IconButton>
      ))}
    </Stack>
  );

  const socialLinks = [
    { url: 'https://drive.google.com/file/d/1ttezjLSvGgdIRuPy_uyI8WC8jD8yxioT/view?usp=sharing', icon: 'academicons:cv' },
    { url: 'https://mail.google.com/mail/u/0/?fs=1&tf=cm&source=mailto&to=jeonghye.kim@kaist.ac.kr', icon: 'ic:round-mail' },
    { url: 'https://scholar.google.com/citations?user=koDFScAAAAAJ', icon: 'academicons:google-scholar' },
    { url: 'https://www.linkedin.com/in/beanie00', icon: 'eva:linkedin-fill' },
    { url: 'https://x.com/beanie0__0', icon: 'fa6-brands:x-twitter' },
  ];

  return (
    <Box>
      <Box sx={{ marginTop: isMobile ? '40px' : '80px', marginBottom: '25px' }}>
        {!isMobile && (
          <img
            height='200px'
            width='200px'
            style={{
              borderRadius: '50%',
              marginTop: '25px',
              marginBottom: '20px',
              marginLeft: '18px',
              border: '6px solid #b9d2fc',
              float: 'right',
              shapeOutside: 'circle(50%)',
            }}
            src='static/common/jeonghye.jpeg'
            alt='Jeonghye Kim'
          />
        )}

        <Typography sx={{ pb: 0, mb: 0, fontSize: { xs: '1rem', sm: '1.0625rem', md: '1.125rem', lg: '1.125rem' } }} variant='h5' paragraph>
          👋 Hello, I&apos;m Beanie
        </Typography>
        <Typography sx={{ pb: 0, mb: 0 }} variant='h2' paragraph>
          Jeonghye Kim
        </Typography>
        <Typography sx={{ pb: 0, mb: 0 }} fontWeight={600} paragraph>
          KAIST Graduate school of Electrical Engineering
        </Typography>

        {isMobile && (
          <img
            height='140px'
            width='140px'
            style={{ borderRadius: '50%', marginTop: '20px', border: '5px solid #b9d2fc'}}
            src='static/common/jeonghye.jpeg'
            alt='Jeonghye Kim'
          />
        )}

        <SummaryBox>
          <SummaryContent1 component='div'>
            <p style={{ marginTop: 0, marginBottom: '14px' }}>
              I'm a Ph.D. student at KAIST, advised by Prof. <a href='https://sites.google.com/view/youngchulsung' target='_blank' rel="noreferrer">Youngchul Sung</a>, and an incoming Student Researcher at{' '}
              <span style={{ whiteSpace: 'nowrap' }}>
                <img src='/static/works/google_logo.png' width='14' height='14' alt='' style={{ verticalAlign: '-1px', marginRight: '5px' }} />
                Google
              </span>{' '}
              (Nov. 2026). Previously, I interned at{' '}
              <span style={{ whiteSpace: 'nowrap' }}>
                <img src='/static/works/Microsoft_logo.png' width='14' height='14' alt='' style={{ verticalAlign: '-1px', marginRight: '5px' }} />
                Microsoft Research
              </span>{' '}
              (<a href='https://microsoft.github.io/debug-gym/' target='_blank' rel="noreferrer">Froggy</a> and <a href='https://github.com/microsoft/agent-lightning' target='_blank' rel="noreferrer">Agent Lightning</a> teams) and{' '}
              <a href='https://www.lgresearch.ai/' target='_blank' rel="noreferrer" style={{ whiteSpace: 'nowrap' }}>
                <span style={{ display: 'inline-block', width: '16px', height: '16px', overflow: 'hidden', position: 'relative', verticalAlign: '-2px', marginRight: '5px' }}>
                  <img src='/static/works/lgresearch.jpg' alt='' style={{ position: 'absolute', width: '142.22px', height: '74.67px', maxWidth: 'none', left: '-15.73px', top: '-29.33px' }} />
                </span>
                LG AI Research
              </a>.
            </p>
            My research focuses on three areas:
            <ul style={{ paddingLeft: '18px', marginTop: '8px', marginBottom: 0 }}>
              <li style={{ marginBottom: '4px' }}>
                <b style={{ color: '#000000' }}>Understanding and Improving LLM Reasoning Behavior:</b>{' '}
                <a href='https://arxiv.org/pdf/2603.24472' target='_blank' rel="noreferrer">Self-Distillation Analysis</a>,{' '}
                <a href='https://arxiv.org/pdf/2603.15500' target='_blank' rel="noreferrer">Strategic Information Allocation</a>,{' '}
                <a href='https://arxiv.org/pdf/2605.10781' target='_blank' rel="noreferrer">Rebellious Student</a>,{' '}
                <a href='https://arxiv.org/pdf/2505.15182' target='_blank' rel="noreferrer">ReflAct</a>.
              </li>
              <li style={{ marginBottom: '4px' }}>
                <b style={{ color: '#000000' }}>Self-Improving Reinforcement Learning (RL):</b>{' '}
                <a href='https://arxiv.org/pdf/2605.10781' target='_blank' rel="noreferrer">Rebellious Student</a>,{' '}
                <a href='https://arxiv.org/pdf/2602.23008' target='_blank' rel="noreferrer">EMPO<sup>2</sup></a>,{' '}
                <a href='https://arxiv.org/pdf/2609.07925' target='_blank' rel="noreferrer">FrogNano</a>.
              </li>
              <li>
                <b style={{ color: '#000000' }}>Task and RL Env Generation:</b>{' '}
                <a href='https://microsoft.github.io/debug-gym/static/papers/ProgramDistill_arxiv.pdf' target='_blank' rel="noreferrer">ProgramDistill</a>,{' '}
                <a href='https://arxiv.org/pdf/2609.07925' target='_blank' rel="noreferrer">FrogNano</a>.
              </li>
            </ul>
            <p style={{ marginTop: '14px', marginBottom: 0 }}>
              Before my Ph.D., I worked as a front-end and Android/iOS developer.{' '}
              <Box component={Link} to='/projects' sx={{ color: '#000', fontWeight: 700, '&:hover': { color: '#000' } }}>View all development work →</Box>
            </p>
          </SummaryContent1>
        </SummaryBox>
      </Box>
      <SocialIcons />
    </Box>
  )
}

About.propTypes = {
  isMobile: PropTypes.bool.isRequired
}
